import * as THREE from 'three'
import Experience from '../Experience.js'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { TransformControls } from 'three/examples/jsm/controls/TransformControls.js'

import Camera from '../Camera.js'
export default class Environment
{
    constructor(envMapIntensity,backgroundColor)
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.debug = this.experience.debug
        this.resources = this.experience.resources
        this.resource = this.resources.items.object
        this.camera = this.experience.camera
        this.canvas=this.experience.canvas
        // Debug
        if(this.debug.active)
        {
            this.debugFolder = this.debug.ui.addFolder('environment')
        }

        this.setSunLight()
        this.setEnvironmentMap()

    }

    setSunLight()
    {
        this.model = this.resource.scene
        this.box = new THREE.Box3().setFromObject(this.model);
        this.size = this.box.getSize(new THREE.Vector3());
        this.center = this.box.getCenter(new THREE.Vector3());
        this.maxDimension = Math.max(this.size.x, this.size.y, this.size.z);
        const bbox = new THREE.Box3().setFromObject(this.model);

        // Calculate the center position and size of the bounding box
        const center = new THREE.Vector3();
        const size = new THREE.Vector3();
        bbox.getCenter(center);
        bbox.getSize(size);
      
    
const directionalLight = new THREE.DirectionalLight('#ffffff', 1.5)
directionalLight.castShadow = true
directionalLight.shadow.mapSize.set(206, 206)
directionalLight.shadow.normalBias = 0.001
this.scene.add(directionalLight)
const directionalLight1 = new THREE.DirectionalLight('#ffffff', 1)
directionalLight1.castShadow = true
directionalLight1.shadow.mapSize.set(206, 206)
directionalLight1.shadow.normalBias = 0.001
this.scene.add(directionalLight1)
const directionalLight2 = new THREE.DirectionalLight('#ffffff', 1.5)
directionalLight2.castShadow = true

directionalLight2.shadow.mapSize.set(206, 206)
directionalLight2.shadow.normalBias = 0.001
this.scene.add(directionalLight2)

  directionalLight.position.set(0.12, 1, 0)
  directionalLight1.position.set(-0.05, 1, 0)
  directionalLight2.position.set(bbox.max.x, bbox.max.y+5, bbox.max.z)




        // Debug
        if(this.debug.active)
        {
            this.debugFolder
                .add(this.sunLight, 'intensity')
                .name('sunLightIntensity')
                .min(0)
                .max(10)
                .step(0.001)
            
            this.debugFolder
                .add(this.sunLight.position, 'x')
                .name('sunLightX')
                .min(- 5)
                .max(5)
                .step(0.001)
            
            this.debugFolder
                .add(this.sunLight.position, 'y')
                .name('sunLightY')
                .min(- 5)
                .max(5)
                .step(0.001)
            
            this.debugFolder
                .add(this.sunLight.position, 'z')
                .name('sunLightZ')
                .min(- 5)
                .max(5)
                .step(0.001)
        }
    }

    setEnvironmentMap()
    {
        // this.environmentMap = {}
        // this.environmentMap.intensity = 5
        // this.environmentMap.texture = this.resources.items.environmentMapTexture
        // console.log(this.resources.items.environmentMapTexture);
        // this.environmentMap.texture.colorSpace = THREE.SRGBColorSpace
        
        // this.scene.environment = this.environmentMap.texture
        // this.color = new THREE.Color('#ffffff')
        // this.scene.background=this.color
        // this.environmentMap.updateMaterials = () =>
        // {
        //     this.scene.traverse((child) =>
        //     {
        //         if(child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial)
        //         {
        //             child.material.envMap = this.environmentMap.texture
        //             child.material.envMapIntensity = this.environmentMap.intensity
        //             child.frustumCulled=false
        //             child.material.dispose()
        //             child.geometry.dispose()
        //             child.material.envMapIntensity =2.5
                   
        //             child.material.needsUpdate = true

        //         }
        //     })
        // }
     
        // Debug
        if(this.debug.active)
        {
            this.debugFolder
                .add(this.environmentMap, 'intensity')
                .name('envMapIntensity')
                .min(0)
                .max(4)
                .step(0.001)
                .onChange(this.environmentMap.updateMaterials)
        }
        this.time = this.experience.time

       
    }
}
